import React from 'react';

export const Skeleton = ({ className = '' }) => (
  <div
    className={`animate-pulse bg-gradient-to-r from-muted via-muted/60 to-muted bg-[length:200%_100%] rounded ${className}`}
    style={{ animation: 'shimmer 1.8s infinite linear' }}
  />
);

export const SkeletonText = ({ lines = 1, className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines })?.map((_, i) => (
      <Skeleton
        key={i}
        className={`h-4 ${i === lines - 1 && lines > 1 ? 'w-3/4' : 'w-full'}`}
      />
    ))}
  </div>
);

export default Skeleton;
